"use strict";

(function() {

	// Incrementing counter ensures each SVG gets a unique namespace
	let svgCounter = 0;

	function prefixSvgIds(svg) {
		const prefix = 'svg' + (++svgCounter);

		// 1. Rewrite class names in <style> blocks
		svg.querySelectorAll('style').forEach(styleEl => {
			styleEl.textContent = styleEl.textContent
				// .classname  →  .svgN-classname
				.replace(/\.(-?[a-zA-Z_][\w-]*)/g, (_, name) => `.${prefix}-${name}`)
				// url(#id)  →  url(#svgN-id)
				// .replace(/url\(#([\w-]+)\)/g, (_, id) => `url(#${prefix}-${id})`);
		});

		// 2. Rewrite class attributes on all elements
		svg.querySelectorAll('[class]').forEach(el => {
			el.setAttribute('class',
				el.getAttribute('class')
					.split(/\s+/)
					.map(c => c ? `${prefix}-${c}` : '')
					.join(' ')
					.trim()
			);
		});

		// 3. Rewrite id attributes
		// svg.querySelectorAll('[id]').forEach(el => {
		// 	el.setAttribute('id', `${prefix}-${el.getAttribute('id')}`);
		// });

		// 4. Rewrite url(#...) in style attributes and presentation attributes
		// svg.querySelectorAll('[style]').forEach(el => {
		// 	el.setAttribute('style',
		// 		el.getAttribute('style')
		// 			.replace(/url\(#([\w-]+)\)/g, (_, id) => `url(#${prefix}-${id})`)
		// 	);
		// });
		// ['fill', 'stroke', 'filter', 'clip-path', 'mask', 'marker-start', 'marker-mid', 'marker-end'].forEach(attr => {
		// 	svg.querySelectorAll(`[${attr}^="url(#"]`).forEach(el => {
		// 		el.setAttribute(attr,
		// 			el.getAttribute(attr)
		// 				.replace(/url\(#([\w-]+)\)/g, (_, id) => `url(#${prefix}-${id})`)
		// 		);
		// 	});
		// });

		// 5. Rewrite href="#..." and xlink:href="#..." (for <use>, <textPath>, etc.)
		// svg.querySelectorAll('[href^="#"]').forEach(el => {
		// 	el.setAttribute('href', '#' + prefix + '-' + el.getAttribute('href').slice(1));
		// });
		// svg.querySelectorAll('[xlink\\:href^="#"]').forEach(el => {
		// 	el.setAttribute('xlink:href', '#' + prefix + '-' + el.getAttribute('xlink:href').slice(1));
		// });
	}

	/* don't run DOM editing code in editing mode, or else the modified elements will be stored */
	/* (or just for speeding up the editing interface where we don't need lots of the interactivity) */
	/* Note: if many pages need cleaning up, it can be a solution to put in a script that is loaded in edit mode (eg link target, nbsp, empty tags) */
	if (!(document.querySelector("body").classList.contains("isEditing"))) {

		// replace all SVGs embedded (by authors) with inline SVG code
		// inspiration: https://github.com/jonnyhaynes/inline-svg / https://gist.github.com/Bloggerschmidt/61beeca2cce94a70c9df
		// requires publishing the .svg extension instead of .ashx
		// BUG: doesn't always catch SVGs inside slideshow (as these are replaced or duplicated at the same time as this script runs)
		let elms = document.querySelectorAll("img[src*='.svg']");
		for (let e of elms) { /* e MUST be a local variable here */
			fetch(e.src)
				.then(response => response.text())
				.then(code => {
					// Note: converting to node and replacing is faster than just doing e.outerHTML = code !
					var svg = new DOMParser().parseFromString(code,"text/xml").querySelector("svg");
					// remove svg id, is often conflicting
					if (svg.hasAttribute("id")) {
						svg.removeAttribute("id");
					}
					// add viewBox if missing
					if (!svg.hasAttribute("viewBox")) {
						svg.setAttribute("viewBox", `0 0 ${svg.getAttribute("width")} ${svg.getAttribute("height")}`)
					}
					// copy all img attributes, except for src and alt
					Array.prototype.slice.call(e.attributes).forEach(function(attribute) {
						if (attribute.name == "alt") {
							if (attribute.value == "") {
								svg.setAttribute("aria-hidden", "true");
							}
							else {
								svg.setAttribute("aria-label", attribute.value);
							}
						}
						else if (attribute.name !== "src") {
							svg.setAttribute(attribute.name, attribute.value);
						}
					});
					prefixSvgIds(svg);
					e.parentNode.replaceChild(svg,e);
				});
		}

	}

})();
